module.exports = __webpack_public_path__ + "img/logo_icon.dafd970e.png";